export default "__VITE_ASSET__BvjK4juE__"